import React, { useState, useRef, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from './AuthContext';

export default function UserMenu() {
  const { user, logout } = useAuth();
  const navigate = useNavigate();
  const [open, setOpen] = useState(false);
  const menuRef = useRef(null);

  useEffect(() => {
    function handleClickOutside(event) {
      if (menuRef.current && !menuRef.current.contains(event.target)) {
        setOpen(false);
      }
    }
    document.addEventListener('mousedown', handleClickOutside);
    return () => document.removeEventListener('mousedown', handleClickOutside);
  }, []);

  if (!user) return null;

  const handleLogout = async () => {
    setOpen(false);
    await logout();
    window.location.href = '/';
  };

  const handleApiKeys = () => {
    setOpen(false);
    navigate('/settings/api-keys');
  };

  return (
    <div ref={menuRef} style={{ position: 'relative' }}>
      <button
        onClick={() => setOpen(!open)}
        style={{
          display: 'flex',
          alignItems: 'center',
          gap: '8px',
          background: 'rgba(255, 255, 255, 0.15)',
          border: 'none',
          borderRadius: 'var(--radius-full, 9999px)',
          padding: '6px 12px 6px 6px',
          cursor: 'pointer',
          color: 'white',
          fontSize: 'var(--font-size-sm, 0.875rem)',
          backdropFilter: 'blur(8px)',
          WebkitBackdropFilter: 'blur(8px)',
          transition: 'background 0.2s ease',
        }}
        onMouseOver={(e) => e.currentTarget.style.background = 'rgba(255, 255, 255, 0.25)'}
        onMouseOut={(e) => e.currentTarget.style.background = 'rgba(255, 255, 255, 0.15)'}
      >
        {user.profile_image_url ? (
          <img
            src={user.profile_image_url}
            alt=""
            style={{
              width: '28px',
              height: '28px',
              borderRadius: '50%',
              objectFit: 'cover',
            }}
          />
        ) : (
          <div style={{
            width: '28px',
            height: '28px',
            borderRadius: '50%',
            background: 'var(--color-accent, #667eea)',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            fontSize: '0.8rem',
            fontWeight: 700,
          }}>
            {(user.display_name || user.email || '?')[0].toUpperCase()}
          </div>
        )}
        <span style={{ maxWidth: '100px', overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>
          {user.display_name || user.email}
        </span>
      </button>

      {open && (
        <div style={{
          position: 'absolute',
          top: '100%',
          right: 0,
          marginTop: '8px',
          background: 'white',
          borderRadius: 'var(--radius-lg, 12px)',
          boxShadow: '0 8px 32px rgba(0, 0, 0, 0.15)',
          minWidth: '200px',
          zIndex: 1100,
          overflow: 'hidden',
          animation: 'fadeInUp 0.2s ease',
        }}>
          <div style={{
            padding: '16px',
            borderBottom: '1px solid #eee',
          }}>
            <div style={{
              fontWeight: 600,
              color: '#333',
              fontSize: '0.9rem',
              marginBottom: '4px',
            }}>
              {user.display_name || 'User'}
            </div>
            <div style={{
              color: '#888',
              fontSize: '0.75rem',
              overflow: 'hidden',
              textOverflow: 'ellipsis',
            }}>
              {user.email}
            </div>
          </div>

          <button
            onClick={handleApiKeys}
            style={{
              width: '100%',
              padding: '12px 16px',
              border: 'none',
              background: 'none',
              cursor: 'pointer',
              textAlign: 'left',
              fontSize: '0.875rem',
              color: '#333',
              transition: 'background 0.15s ease',
              display: 'flex',
              alignItems: 'center',
              gap: '8px',
              borderBottom: '1px solid #eee',
            }}
            onMouseOver={(e) => e.currentTarget.style.background = '#f5f5f5'}
            onMouseOut={(e) => e.currentTarget.style.background = 'none'}
          >
            🔑 API 키 관리
          </button>

          <button
            onClick={handleLogout}
            style={{
              width: '100%',
              padding: '12px 16px',
              border: 'none',
              background: 'none',
              cursor: 'pointer',
              textAlign: 'left',
              fontSize: '0.875rem',
              color: '#dc3545',
              transition: 'background 0.15s ease',
              display: 'flex',
              alignItems: 'center',
              gap: '8px',
            }}
            onMouseOver={(e) => e.currentTarget.style.background = '#fff5f5'}
            onMouseOut={(e) => e.currentTarget.style.background = 'none'}
          >
            로그아웃
          </button>
        </div>
      )}
    </div>
  );
}
